import { gql } from '@apollo/client';

export const UPDATE_BOARDER_MEALS = gql`
  mutation UpdateBoarderMeals($input: UpdateBoarderMealsInput!) {
    updateBoarderMeals(input: $input) {
      boarderId
    }
  }
`;
